import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './PageTransition.css';

const PageTransition = ({ children }) => {
  const location = useLocation();
  const [key, setKey] = useState(0);
  const prevPathnameRef = useRef(location.pathname);

  useEffect(() => {
    // Détecter le changement de route
    if (location.pathname !== prevPathnameRef.current) {
      prevPathnameRef.current = location.pathname;
      // Changer la clé pour forcer une nouvelle animation
      setKey(prev => prev + 1);
    }
  }, [location.pathname]);

  return (
    <div key={key} className="page-transition page-transition-entering">
      {children}
    </div>
  );
};

export default PageTransition;

